import React, { useState } from 'react';
import { Box, Stepper, Step, StepLabel, StepContent, Paper } from '@mui/material';

import { SimButton } from 'components/SimButton';
import { SimTypography } from 'components/SimTypography';

import SimPopupBoxForm from 'components/SimPopupBoxForm';

const VerticalStepper = () => {
	const [activeStep, setActiveStep] = useState(0);
	const [editFlag, setEditFlag] = useState('0');
	const [open, setOpen] = useState(false);

	const handleNext = () => {
		setActiveStep(prevActiveStep => prevActiveStep + 1);
	};

	const handleBack = () => {
		setActiveStep(prevActiveStep => prevActiveStep - 1);
	};

	const handleReset = () => {
		setActiveStep(0);
	};

	return (
		<Box width={'90vw'}>
			<Box>
				<Stepper activeStep={activeStep} orientation='vertical'>
					<Step
						key={'0'}
						sx={{
							'& .MuiSvgIcon-root': {
								width: 28,
								height: 28
							}
						}}>
						<StepLabel
							sx={{
								'& .MuiStepLabel-label': {
									fontWeight: 700
								}
							}}>
							<SimTypography variant='h6'>Provide your information</SimTypography>
						</StepLabel>
						<StepContent>
							<SimTypography>
								{' '}
								Your information across the steps below will help us serve you better
							</SimTypography>

							<Box sx={{ mb: 2 }}>
								<Box display='flex'>
									<SimButton
										variant={'contained'}
										onClick={handleNext}
										sx={{ mt: 2, mr: 2, width: { xs: '60vw', sm: '30vw', md: '30vw' } }}>
										Start
									</SimButton>
								</Box>
							</Box>
						</StepContent>
					</Step>

					<Step
						key={1}
						sx={{
							'& .MuiSvgIcon-root': {
								width: 28,
								height: 28
							}
						}}>
						<StepLabel
							sx={{
								'& .MuiStepLabel-label': {
									fontWeight: 700
								}
							}}>
							<SimTypography variant='h6'>Referral Section</SimTypography>
						</StepLabel>
						<StepContent>
							<SimTypography> Please enter details of the doctor referring your case</SimTypography>

							<Box sx={{ mb: 2 }}>
								<Box
									display='flex'
									flexDirection={{ xs: 'column' }}
									alignContent='flex-start'
									alignItems={'flex-start'}
									justifyContent='left'>
									<SimButton
										variant={'outlined'}
										onClick={handleNext}
										sx={{ mt: 2, mr: 2, width: { xs: '60vw', sm: '30vw', md: '30vw' } }}>
										<SimTypography sx={{ fontWeight: 700 }}>I have not been referred</SimTypography>
									</SimButton>
								</Box>

								<Box
									display='flex'
									flexDirection={{ xs: 'column' }}
									alignContent='flex-start'
									alignItems={'flex-start'}
									justifyContent='left'>
									<SimButton
										variant='contained'
										color={'primary'}
										sx={{ mt: 2, mr: 2, width: { xs: '60vw', sm: '30vw', md: '30vw' } }}
										onClick={() => {
											setOpen(true);
											setEditFlag('Referral');
										}}>
										Add Referral Details
									</SimButton>

									<SimPopupBoxForm Referral open={open} onClose={() => setOpen(false)} />

									<SimButton
										variant='outlined'
										onClick={handleNext}
										width={{ xs: '70vw', md: '90vw' }}
										sx={{ mt: 2, mr: 2, width: { xs: '60vw', sm: '30vw', md: '30vw' } }}>
										{editFlag === 'Referral' ? 'Proceed' : 'Skip & Continue'}
									</SimButton>

									<SimButton
										variant={'outlined'}
										disabled={false}
										onClick={handleBack}
										sx={{ mt: 2, mr: 2, width: { xs: '60vw', sm: '30vw', md: '30vw' } }}>
										Back
									</SimButton>

									<SimButton
										variant={'outlined'}
										disabled={false}
										onClick={handleReset}
										sx={{ mt: 2, mr: 2, width: { xs: '60vw', sm: '30vw', md: '30vw' } }}>
										Quit
									</SimButton>
								</Box>
							</Box>
						</StepContent>
					</Step>

					<Step
						key={2}
						sx={{
							'& .MuiSvgIcon-root': {
								width: 28,
								height: 28
							}
						}}>
						<StepLabel
							sx={{
								'& .MuiStepLabel-label': {
									fontWeight: 700
								}
							}}>
							<SimTypography variant='h6'>Patient Section</SimTypography>
						</StepLabel>
						<StepContent>
							<SimTypography> Please provide details of the person needing therapy</SimTypography>

							<Box sx={{ mb: 2 }}>
								<Box
									display='flex'
									flexDirection={{ xs: 'column' }}
									alignContent='flex-start'
									alignItems={'flex-start'}
									justifyContent='left'>
									<Box>
										<SimButton
											variant='contained'
											color={'primary'}
											sx={{ mt: 2, mr: 2, width: { xs: '60vw', sm: '30vw', md: '30vw' } }}
											onClick={() => {
												setOpen(true);
												setEditFlag('Patient');
											}}>
											Add Patient Details
										</SimButton>
										<SimPopupBoxForm Patient open={open} onClose={() => setOpen(false)} />
									</Box>

									<SimButton
										variant='outlined'
										onClick={handleNext}
										sx={{ mt: 2, mr: 2, width: { xs: '60vw', sm: '30vw', md: '30vw' } }}>
										{editFlag === 'Patient' ? 'Proceed' : 'Skip & Continue'}
									</SimButton>

									<SimButton
										variant={'outlined'}
										disabled={false}
										onClick={handleBack}
										sx={{ mt: 2, mr: 2, width: { xs: '60vw', sm: '30vw', md: '30vw' } }}>
										Back
									</SimButton>
									<SimButton
										variant={'outlined'}
										disabled={false}
										onClick={handleReset}
										sx={{ mt: 2, mr: 2, width: { xs: '60vw', sm: '30vw', md: '30vw' } }}>
										Quit
									</SimButton>
								</Box>
							</Box>
						</StepContent>
					</Step>

					<Step
						key={3}
						sx={{
							'& .MuiSvgIcon-root': {
								width: 28,
								height: 28
							}
						}}>
						<StepLabel
							sx={{
								'& .MuiStepLabel-label': {
									fontWeight: 700
								}
							}}>
							<SimTypography variant='h6'>Parent / Caregiver Section</SimTypography>
						</StepLabel>
						<StepContent>
							<SimTypography>
								{' '}
								Please provide details of any one parent, guardian or caregiver
							</SimTypography>
							<Box sx={{ mb: 2 }}>
								<Box
									display='flex'
									flexDirection={{ xs: 'column' }}
									alignContent='flex-start'
									alignItems={'flex-start'}
									justifyContent='left'>
									<Box>
										<SimButton
											variant='contained'
											color={'primary'}
											sx={{ mt: 2, mr: 2, width: { xs: '60vw', sm: '30vw', md: '30vw' } }}
											onClick={() => {
												setOpen(true);
												setEditFlag('Caregiver');
											}}>
											Add Caregiver Details
										</SimButton>
										<SimPopupBoxForm Caregiver open={open} onClose={() => setOpen(false)} />
									</Box>

									<SimButton
										variant='outlined'
										onClick={handleNext}
										sx={{ mt: 2, mr: 2, width: { xs: '60vw', sm: '30vw', md: '30vw' } }}>
										{editFlag === 'Caregiver' ? 'Proceed' : 'Skip & Continue'}
									</SimButton>

									<SimButton
										variant={'outlined'}
										disabled={false}
										onClick={handleBack}
										sx={{ mt: 2, mr: 2, width: { xs: '60vw', sm: '30vw', md: '30vw' } }}>
										Back
									</SimButton>
									<SimButton
										variant={'outlined'}
										disabled={false}
										onClick={handleReset}
										sx={{ mt: 2, mr: 2, width: { xs: '60vw', sm: '30vw', md: '30vw' } }}>
										Quit
									</SimButton>
								</Box>
							</Box>
						</StepContent>
					</Step>

					<Step
						key={4}
						sx={{
							'& .MuiSvgIcon-root': {
								width: 28,
								height: 28
							}
						}}>
						<StepLabel
							sx={{
								'& .MuiStepLabel-label': {
									fontWeight: 700
								}
							}}>
							<SimTypography variant='h6'>Insurance Section</SimTypography>
						</StepLabel>
						<StepContent>
							<SimTypography>
								{' '}
								Please provide details of the insurance services the patient is enrolled with
							</SimTypography>

							<Box sx={{ mb: 2 }}>
								<Box
									display='flex'
									flexDirection={{ xs: 'column' }}
									alignContent='flex-start'
									alignItems={'flex-start'}
									justifyContent='left'>
									<Box>
										<SimButton
											variant='contained'
											color={'primary'}
											sx={{ mt: 2, mr: 2, width: { xs: '60vw', sm: '30vw', md: '30vw' } }}
											onClick={() => {
												setOpen(true);
												setEditFlag('Insurance');
											}}>
											Add Insurance Details
										</SimButton>
										<SimPopupBoxForm Insurer open={open} onClose={() => setOpen(false)} />
									</Box>

									<SimButton
										variant='outlined'
										onClick={handleNext}
										sx={{ mt: 2, mr: 2, width: { xs: '60vw', sm: '30vw', md: '30vw' } }}>
										{editFlag === 'Insurance' ? 'Proceed' : 'Skip & Continue'}
									</SimButton>

									<SimButton
										variant={'outlined'}
										disabled={false}
										onClick={handleBack}
										sx={{ mt: 2, mr: 2, width: { xs: '60vw', sm: '30vw', md: '30vw' } }}>
										Back
									</SimButton>

									<SimButton
										variant={'outlined'}
										disabled={false}
										onClick={handleReset}
										sx={{ mt: 2, mr: 2, width: { xs: '60vw', sm: '30vw', md: '30vw' } }}>
										Quit
									</SimButton>
								</Box>
							</Box>
						</StepContent>
					</Step>
				</Stepper>

				{activeStep === 5 && (
					<Paper square elevation={0} sx={{ p: 3 }}>
						<SimTypography>All steps completed - you&apos;re finished</SimTypography>
						<SimButton variant={'outlined'} onClick={handleReset} sx={{ mt: 2, mr: 2 }}>
							Reset
						</SimButton>
					</Paper>
				)}
			</Box>
		</Box>
	);
};

export { VerticalStepper };
